import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { LiquidityCampaign } from '@arcxgame/contracts/dist/src/typings'
import { BigNumber, Contract, ContractTransaction, Signer } from 'ethers'
import { Network } from 'src/config'
import ArcFarm from './ArcFarm'

export class LiquidityCampaignFarm extends ArcFarm {
  constructor(
    name: string,
    platform: string,
    pair: string,
    pairLink: string,
    note: string,
    signer: Signer,
    network: Network,
    public contract: LiquidityCampaign,
    client: ApolloClient<NormalizedCacheObject>,
  ) {
    super(name, platform, pair, pairLink, note, signer, network, contract, client)
  }

  /* ========== Getters ========== */

  hasDebtRequirement(): boolean {
    return false
  }

  async getAvailableToStake(): Promise<BigNumber> {
    const stakingToken = await this.getStakingToken()

    const stakableBalance = await stakingToken.balanceOf(await this.signer.getAddress())

    return stakableBalance
  }

  async getStakedBalance(): Promise<BigNumber> {
    try {
      return await super.getStakedBalance()
    } catch (err) {
      console.error(
        'Error calling contract.balanceOf(address). This is probably farm 6. Trying .balanceOfStaker',
      )
    }

    try {
      const contract = new Contract(
        this.contract.address,
        ['function balanceOfStaker(address staker) view returns(uint256)'],
        this.signer,
      )
      return await contract.balanceOfStaker(await this.signer.getAddress())
    } catch (err) {
      console.error('Error calling contract.balanceOfStaker(address)', err)
    }

    return BigNumber.from(0)
  }

  /* ========== Modifiers ========== */

  async stake(amount: BigNumber): Promise<ContractTransaction> {
    const stakingToken = await this.getStakingToken()
    const allowance = await stakingToken.allowance(
      await this.signer.getAddress(),
      this.contract.address,
    )

    if (allowance.lt(amount)) {
      try {
        const tx = await stakingToken.approve(this.contract.address, amount.toString())
        await tx.wait()
      } catch {
        // If an approval is failing it's probably because it's a curve token LP token wanting
        // the approval to be set to 0 smh...
        const resetApproval = await stakingToken.approve(this.contract.address, 0)
        await resetApproval.wait()

        const approveTx = await stakingToken.approve(this.contract.address, amount.toString())
        await approveTx.wait()
      }
    }

    try {
      const stakeTx = await this.contract.stake(amount)
      return stakeTx
    } catch (err) {
      console.error(err)
      throw Error('An error occured during staking')
    }
  }
}
